import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"
import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import StatCard from "./StatCard"
import { getDateLabel } from "./utils/dateLabels"

Expenses.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function Expenses({ params }) {
  const { t } = useTranslation()
  const { expenses_stats, date_range } = useSelector(metadataSelector("accounting"))
  const dates = getDateLabel(params, date_range?.label)

  return (
    <StatCard
      title={t("accounting.labels.expenses")}
      tooltip={t("accounting.labels.expense_value_tooltip", { dates })}
      dates={dates}
      value={numberToCurrency(expenses_stats[params.overview_range])}
      monthlyDiff={expenses_stats.monthly_diff}
      isCurrentMonth={params.overview_range === "current_month"}
    />
  )
}
